import { useSyncExternalStore } from 'react';

import authentication from '../utilities/Authentication';

/**
 * Reactive read of the Auth0 access token off the Authentication singleton.
 *
 * An empty string means "no token yet" -- the pre-callback render, logged out, or
 * cleared by checkExpiration. Subscribing rather than reading localStorage directly
 * is what lets `enabled: hasToken` gates re-open the moment saveLoginInfo runs.
 * Without it a gate can latch shut: the providers that fetch are parents of App,
 * and App is what drives the Auth0 handshake, so nothing guarantees they re-render
 * when the token finally lands.
 *
 * No getServerSnapshot argument -- CRA renders client-only via createRoot, so React
 * never calls it.
 */
export function useAuthToken() {
  const token = useSyncExternalStore(authentication.subscribe, () =>
    authentication.getAccessToken()
  );

  return { token, hasToken: !!token };
}
